import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../context/index";
import PropTypes from "prop-types";
import isMobilePhone from "validator/lib/isMobilePhone";
import LeadForm from "./indexForm";
import UrlError from "./urlError";
import { Box, CircularProgress } from "@mui/material";
import { useLocation, useHistory } from "react-router-dom";
import { ReducerUtils } from "../../constants/reducers";
import { useStyles } from "./indexStyles";
import { validations } from "../../messages/validation";
import { withStyles } from "@mui/styles";
import { getWebService, postWebService } from "../../helpers/server";
import {
  clearStorageItem,
  getQueryStringParameterValue,
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../helpers/utils";
import {
  errorMessageObject,
  initialFormState,
  touchFieldsObject,
} from "../../defaultValues/lead";
import {
  FORM_FIELD_HAS_ERROR,
  FORM_FIELD_MOBILE,
  FORM_FIELD_STEP,
} from "../../constants/field";
import {
  DEFAULT_PARTNER_SLUG,
  SLUG_EN_IN,
  SLUG_LOGIN,
  SLUG_OTP,
  SLUG_SNACK_BAR,
} from "../../constants";
import {
  buildCustomTokenHeader,
  buildGenerateOtpPayload,
  buildVerifyOtpPayload,
  buildWrapperTokenHeader,
} from "../../helpers/lead";
import { Utils } from "../../constants/utils";

const Lead = ({ classes: { loaderBox } }) => {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState({ ...errorMessageObject });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...initialFormState });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({ snackbar: false, alert: false });
  const [onfocusMobile, setOnfocusMobile] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(true);
  const [touchFields, setTouchFields] = useState({ ...touchFieldsObject });
  const [isToggled, setIsToggled] = useState(false);
  const [incorrectCode, setIncorrectCode] = useState(false);

  useEffect(() => {
    clearStorageItem();

    const cbPartnerDetails = (data, partner_code) => {
      dispatchEvent(ReducerUtils.partner.details, data);
      const { partner_slug, id, name, product_name, product_id, category_id } =
        data;
      const branch = getQueryStringParameterValue("branch") ?? "";
      const code = getQueryStringParameterValue("code") ?? "";

      setStorageItem("partnerCode", partner_code);
      setStorageItem("partner", partner_slug);
      setStorageItem("partnerId", id);
      setStorageItem("partnerName", name);
      setStorageItem("productName", product_name);
      setStorageItem("defaultProductId", product_id);
      setStorageItem("productCategory", category_id);

      if (code) {
        setStorageItem("code", code);
      }

      if (branch) {
        setStorageItem("partnerBranchCode", branch);
      }

      setIsLoaded(true);
    };

    async function fetchPartnerDetails(partner, user_category) {
      try {
        const response = await getWebService(
          `partner.php?partner=${partner}&user_category=${user_category}`,
          {}
        );

        cbPartnerDetails(response.data, partner);
      } catch (error) {
        // console.log(error);
      }
    }

    const cbUserDetails = ({
      code,
      data: { partner_code, user_category, user_id } = {},
      status,
    }) => {
      if (code === 200 && status) {
        setStorageItem("uid", user_id);
        setStorageItem("userType", user_category);

        fetchPartnerDetails(partner_code, user_category);
      } else {
        setIncorrectCode(true);
      }
    };

    async function fetchUserDetails() {
      try {
        const branch = getQueryStringParameterValue("branch") ?? null;
        const code = getQueryStringParameterValue("code") ?? null;
        const partner =
          getQueryStringParameterValue("partner") ?? DEFAULT_PARTNER_SLUG;

        let url = `user.php?partner=${partner}`;

        if (code) {
          url = `user.php?partner=${partner}&code=${code}`;
        }

        if (branch) {
          url = `${url}&branch_code=${branch}`;
        }

        const response = await getWebService(url, {});
        cbUserDetails(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    const cbSuccessWrapperToken = ({ access_token }) => {
      setStorageItem("access-token", access_token);
    };

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        cbSuccessWrapperToken(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    fetchUserDetails();
    wrapperToken();
  }, []);

  useEffect(() => validateMobile(FORM_FIELD_MOBILE), [form[FORM_FIELD_MOBILE]]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleChange = (event) => {
    setErrors([]);
    setFormState(event.target.name, event.target.value);
  };

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(modalKey, false);
    }
  };

  const handleChangeChipSelect = (name, value) => setFormState(name, value);

  const handleReinitiateJourney = () => window.location.reload();

  const handleChangeMobile = () => {
    setErrors([]);
    setFormState("step", SLUG_LOGIN);
  };

  const handleCheckboxChange = (event) => {
    setFormState(event.target.name, event.target.checked);
    setIsToggled(event.target.checked);
  };

  const handleToggle = (event) => {
    event.stopPropagation();
    setIsToggled((prev) => !prev);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setStateVariables = (key, isValid, message) => {
    setFormState(FORM_FIELD_HAS_ERROR, !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const toggleClass = () => setOnfocusMobile(true);

  const toggleModal = (keyname = SLUG_SNACK_BAR, flag = true) =>
    setModal({ [keyname]: flag });

  const validateMobile = (fieldName) => {
    if (form[fieldName]) {
      let isValid = isMobilePhone(form[fieldName], [SLUG_EN_IN]);
      setStateVariables(
        fieldName,
        isValid,
        isValid ? "" : validations[fieldName].valid
      );
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  /* Start: Generate and Verify OTP */
  const cbError = (error) => setIsFormSubmitted(false);

  const cbSuccessVerifyOtp = ({ data }, checksum) => {
    setIsFormSubmitted(false);
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);

    const dataJSON = JSON.parse(atob(dataSlice));

    if (dataJSON[0].success_code == 202 && dataJSON[0].checksum == checksum) {
      const {
        cid,
        existing = false,
        isInstaPolicyConfirmation = false,
        oid = "",
        token,
      } = dataJSON[0];

      if (isInstaPolicyConfirmation === true) {
        setForm({ ...form, alert: true });
        toggleModal("alert", true);
      } else {
        setStorageItem("app-token", token);
        setStorageItem("mobile", form.mobile);
        setStorageItem("cid", cid);
        setStorageItem("oid", oid);
        navigateTo(getRoute(existing ? "application" : "product"));
      }
    } else {
      setErrors(new Array(dataJSON[0]?.msg));
    }
  };

  const onSubmitVerifyOtp = async () => {
    try {
      setErrors([]);
      setIsFormSubmitted(true);
      const checksum = makeid();
      const response = await postWebService(
        "validateotp.php",
        {
          ...buildVerifyOtpPayload(form, checksum),
          uid: Number(getStorageItem("uid")),
          pid: Number(getStorageItem("defaultProductId")),
        },
        buildCustomTokenHeader()
      );

      cbSuccessVerifyOtp(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessGenerateOtp = ({ success_code, msg = null }) => {
    setIsFormSubmitted(false);
    if (success_code == 403) {
      setErrors(new Array(msg));
    } else {
      toggleModal(SLUG_SNACK_BAR, true);
      setFormState(FORM_FIELD_STEP, SLUG_OTP);
    }
  };

  const onSubmitGenerateOtp = async () => {
    try {
      setErrors([]);
      setIsFormSubmitted(true);
      const response = await postWebService(
        "otp.php",
        buildGenerateOtpPayload(form),
        buildCustomTokenHeader()
      );

      cbSuccessGenerateOtp(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    form[FORM_FIELD_STEP] === SLUG_OTP
      ? onSubmitVerifyOtp()
      : onSubmitGenerateOtp();
  };
  /* End: Generate and Verify OTP */

  return incorrectCode ? (
    <UrlError />
  ) : isLoaded && state?.partnerDetails ? (
    <LeadForm
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleChange={handleChange}
      handleChangeMobile={handleChangeMobile}
      handleChangeChipSelect={handleChangeChipSelect}
      handleCheckboxChange={handleCheckboxChange}
      handleClose={handleClose}
      handleOnClose={handleOnClose}
      handleReinitiateJourney={handleReinitiateJourney}
      handleToggle={handleToggle}
      isFormSubmitted={isFormSubmitted}
      isToggled={isToggled}
      modal={modal}
      onfocusMobile={onfocusMobile}
      onSubmit={onSubmit}
      onSubmitGenerateOtp={onSubmitGenerateOtp}
      setFormState={setFormState}
      showOtpInput={showOtpInput}
      toggleClass={toggleClass}
      toggleModal={toggleModal}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
};

Lead.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(Lead);
